import "./footer.scss";

import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { lowerLanguage } from "src/i18n";
import {
  atomReloadCookie,
  selectorAgency,
  selectorDocuments,
  selectorWebPolicyDocument,
  useRootOutcomes,
} from "src/storage";

export const useFooter = () => {
  const { t } = useTranslation();

  const navigate = useNavigate();

  const { topRootOutcome, removeRootOutcomes } = useRootOutcomes();

  const errorCode = topRootOutcome?.awsGateError?.errorCode;
  const errorDesc = topRootOutcome?.awsGateError?.errorDescription;

  useEffect(() => {
    removeRootOutcomes();
  }, []);

  const documents = useRecoilValue(selectorDocuments);
  const webPolicyDocument = useRecoilValue(selectorWebPolicyDocument);
  const agency = useRecoilValue(selectorAgency);
  const setReloaded = useSetRecoilState(atomReloadCookie);

  const webPolicy = webPolicyDocument?.[lowerLanguage];

  return {
    t,
    navigate,
    removeRootOutcomes,
    documents,
    agency,
    setReloaded,
    webPolicy,
  };
};
